export const DataFields = (t) => {
  return [
    {
      name: "",
      fields: [
        {
          id: "name",
          name: t('users_form_name'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "phone",
          name: t('users_form_phone'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "email",
          name: t('users_form_email'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "password",
          name: t('users_form_password'),
          type: "password",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "role",
          name: t('users_form_role'),
          type: "select",
          containerOptions: "roles",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "branch_offices",
          name: t('users_form_branch_office'),
          type: "multiselect",
          containerOptions: "branch_offices",
          required: true,
          defaultValue: [],
          size: "small"
        },
        {
          id: "active",
          name: t('users_form_active'),
          type: "switch",
          required: true,
          defaultValue: false,
          size: "small"
        },
      ]
    }
  ]
}